/**
 * @description: 计时开房列表
 * @author: cyp
 * @update: hwx
 * @update: lyr(22-03-10)
 */
<template>
<div class="timing_manage page_content">
	<!-- 计时开房列表 -->
	<div class="timing-list" v-show="showlist">
		<div class="row row-btn" v-if="list_menu_add">
			<button type="button" class="btn bg-orange btn-middle bigbtn" @click="add_timing_page">计时开房设置</button>
			<button type="button" class="btn bg-orange btn-middle bigbtn" @click="openBdpri">包断价格管理</button>
		</div>
		<div class="row row-margin">
			<label class="col-md-1 list-label-2">门店:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="timing_shop_input" data-placeholder="请选择门店"></select>
			</div>
			<label class="col-md-1 list-label-4">包厢类型:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="list_box_type" data-placeholder="请选择包厢类型"></select>
			</div>
			<div class="pull-right">
				<button type="button" class="btn bg-orange btn-flat btn-small" @click="queryList()">查询</button>
			</div>
		</div>
		<p>注：计时开房设置里的包断价格管理与包断价格管理及修改进去的节假日价格设置三者设置的在APP上显示优先级原则为：节假日价格>包断价格管理>计时开房包断价格</p>
		<div class="table-responsive">
			<table ref="timing_manage_table" class="table table-bordered table-hover" data-pagination="true"></table>
		</div>
	</div>
	<!--添加、修改计时套餐-->
	<div class="add_printer details_content" v-show="showdetail">
		<div class="page_header">{{add_header}}</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">门店:</label>
			<div class="col-md-5">
				<select class="form-control select2" ref="add_shop_name" data-placeholder="请选择门店">
				</select>
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">优先级:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="请输入优先级(数字大的优先)" v-model="timing_listorder" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" />
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">适用包厢类型:</label>
			<div class="col-md-5">
				<input class="form-control input-readonly canselect" placeholder="请选择适用包厢类型" v-model="timing_room_type" ref="timing_room_type" readonly="readonly" @click="room_type_fun($event)">
				<span class="selection_clear" @click="clear_input('timing_room_type')">×</span>
				<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">适用包厢号:</label>
			<div class="col-md-5">
				<input class="form-control input-readonly" placeholder="请选择包厢号" v-model="edit_box" ref="edit_box" readonly disabled @click="editBoxFun">
				<span class="selection-clear" @click="clearInput('edit_box')">×</span>
				<span class="span-arrow"><b></b></span>
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">有效星期日:</label>
			<div class="col-md-5">
				<input class="form-control input-readonly" placeholder="请选择有效的星期日" v-model="validity_date_name" ref="validity_date_name" @click="week_data_fun($event)" readonly="readonly">
				<span class="selection_clear" @click="clear_input('validity_date_name')">×</span>
				<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">可使用时间:</label>
			<div class="col-md-5">
				<input class="form-control input-readonly" placeholder="请选择可使用时间"  v-model="edit_use_time" ref="edit_use_time" @click="chooseTimePop($event)" readonly="readonly">
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">计时单价:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="请填写计时单价(每小时的价格)" v-model="time_cost_price" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" />
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">会员计时单价:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="会员计时单价指在使用会员卡支付时的计时单价" v-model="vip_cost_price" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" />
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">低消金额:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="请输入低消金额，满低消可以免包厢时间费" v-model="lowest_cost_price" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" />
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">会员低消金额:</label>
			<div class="col-md-5">
				<input type="text" class="form-control"  placeholder="会员低消金额指会员使用会员卡支付时的低消金额" v-model="viplowest_cost_price" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" />
			</div>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">酒水不满低消设置:</label>
			<div class="col-md-5">
				<select class="form-control select2" style="width: 100%;" ref="drink_get_type">
					<option value="1">收实际时间费</option>
					<option value="2">收到低消的金额</option>
				</select>
			</div>
			<span class="rmarkspan" titles="例如：小李在A包厢（计时单价200元/小时，低消金额800元）。消费了3小时，酒水消费500元。最后消费计算<br/>1，收到低消金额计算：500+300=800元<br/>2，按照实际时间费计算：500+3*200=1100元" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">包断金额:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="请输入包厢费包断金额" v-model="box_cost_price" />
			</div>
			<span class="rmarkspan" titles="包断金额=-1时，不启用包断功能<br/>包断金额=0时，按0元计算" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
		</div>
		<div class="row rowpadding">
			<label class="col-md-1 control-label" style="width: 140px;">会员包断金额:</label>
			<div class="col-md-5">
				<input type="text" class="form-control" placeholder="会员包断金额指会员使用会员卡支付时的包断金额" v-model="vipbox_cost_price" />
			</div>
		</div>
		<!--div class="row rowpadding">
		<label class="col-md-1 control-label" style="width: 110px;">跨时段是否续用:</label>
		<div class="col-md-4" style="line-height: 32px;">
	        <input type="radio" name="ismenu" class="radiobig" value="-1" v-model="intertemporal">
			<label class="control-label">否</label>
	        <input type="radio" name="ismenu" class="radiobig" value="1" v-model="intertemporal" style="margin-left: 30px;">
			<label class="control-label">是</label>
			<span class="rmarkspan" titles="[是]夸时段后按照开房计时单价收费</br>　[否]按照跨时段后面的计时单价收费" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
	    </div>
		</div-->
		<div class="price-set-title">—————— 不同会员等级会员金额设置 ——————</div>
		<div class="price-set-row">
			<div class="row-title">一级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level1_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level1_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level1_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">二级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level2_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level2_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level2_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">三级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level3_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level3_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level3_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">四级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level4_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level4_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level4_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">五级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level5_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level5_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level5_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">六级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level6_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level6_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level6_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">七级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level7_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level7_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level7_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">八级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level8_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level8_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level8_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">九级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level9_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level9_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level9_price" />
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">十级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level10_price" />
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="vip_level10_minimum_consumption" />
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<input type="text" class="form-control" placeholder="请输入金额" v-model="bd_vip_level10_price" />
			</div>
		</div>

		<div class="row" style="padding-top: 30px;">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
			<button type="button" class="btn btn-flat btn-middle btn-orange"style="margin-left: 40px;" @click="add_update_roomtiming(addorupdate)">保存</button>
		</div>


		<!-- 节假日计时设置 -->
		<div class="rule-con" v-show="addorupdate == '2'">
			<div class="page_header">节假日计时设置</div>
			<div class="row rowmargin">
				<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addRule">新增</button>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="rule_list"></table>
			</div>
		</div>
		<!-- 新增、修改 -->
		<div class="rule-edit" ref="rule_edit">
			<div class="row">
				<div class="col-md-6">
					<div class="row">
						<label class="col-md-3 control-label">节假日名称:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="请填写节假日名称，如：元旦计时价格" v-model="rule_name">
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">适用日期:</label>
						<div class="col-md-9">
							<div class="time-wrapper" ref="rule_time_wrap">
								<input type="text" class="form-control laydate-icon" v-model="rule_time_range" placeholder="请选择适用日期">
							</div>
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">计时单价:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="请填写计时单价（每小时的价格）" v-model="rule_price">
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">会员计时单价:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="会员计时单价指在使用会员卡支付时的计时单价" v-model="rule_vip_price">
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row">
						<label class="col-md-3 control-label">低消金额:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="请输入低消金额，满低消可以免包厢时间费" v-model="rule_min">
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">会员低消金额:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="会员抵消金额指会员使用会员卡支付时的低消金额" v-model="rule_vip_min">
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">包断金额:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="请输入包厢费包断金额" v-model="rule_bd">
						</div>
					</div>
					<div class="row">
						<label class="col-md-3 control-label">会员包断金额:</label>
						<div class="col-md-9">
							<input class="form-control" placeholder="会员包断金额指会员使用会员卡支付时的包断金额" v-model="rule_vip_bd">
						</div>
					</div>
				</div>
				<div class="price-set-title">—————— 不同会员等级会员金额设置 ——————</div>
				<div class="price-set-row" v-for="(item,index) in rule_diffrent_vip_price">
					<div class="row-title">{{index | formatIndex}}级会员价：</div>
					<div class="item">
						<div class="txt">计时单价</div>
						<input type="text" class="form-control" placeholder="请输入金额" v-model="item[`vip_level${index+1}_price`]" />
					</div>
					<div class="item">
						<div class="txt">低消金额</div>
						<input type="text" class="form-control" placeholder="请输入金额" v-model="item[`vip_level${index+1}_minimum_consumption`]" />
					</div>
					<div class="item">
						<div class="txt">包断金额</div>
						<input type="text" class="form-control" placeholder="请输入金额" v-model="item[`bd_vip_level${index+1}_price`]" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 包厢号 -->
	<div class="multi-page" ref="box_area" v-show="showBox">
		<div class="page-tit">选择包厢</div>
		<p>请选择包厢范围</p>
		<div class="multi-page-main">
			<div class="multi-page-row">
				<div>
					<input type="checkbox" v-model='box_all' @click='boxAll'>
					<span>全部包厢</span>
				</div>
				<ul></ul>
			</div>
			<div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
				<div>
					<input type="checkbox" v-model='box_floor' :value="items.room_area" @click="boxFloor(items.room_area, index)">
					<span>{{items.room_area_name}}</span>
				</div>
				<ul class="clearfix">
					<li v-for="item in items.room" :key="item.id">
						<input type="checkbox" v-model='box_item' :value="item.id">
						<span>{{item.name}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="row">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="boxBackEdit">返回</button>
			<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="saveBox()">确定</button>
		</div>
	</div>
	<!-- 包断价格管理 -->
	<div class="timing-bdpri" v-show="showbdpri">
		<div class="page-tit">包断价格管理</div>
		<div class="row row-margin">
			<button type="button" class="btn bg-orange btn-middle" @click="addBdpri">新增</button>
		</div>
		<div class="row row-margin">
			<label class="col-md-1 list-label-2">门店:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="bdpri_sel_shop" data-placeholder="请选择门店"></select>
			</div>
			<label class="col-md-1 list-label-4">包厢类型:</label>
			<div class="col-md-2 ct-col">
				<select class="form-control" ref="bdpri_sel_type" data-placeholder="请选择包厢类型"></select>
			</div>
			<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryBdpri">查询</button>
		</div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="bdpri_list"></table>
		</div>
		<div class="row">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
		</div>
	</div>

	<!-- 包断新增、修改 -->
	<div class="bdpri-edit" ref="bdpri_edit">
		<div class="row">
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 control-label">适用门店:</label>
					<div class="col-md-9 ct-col">
						<select class="form-control" ref="bdpri_shop"></select>
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">适用包厢类型:</label>
					<div class="col-md-9">
						<input class="form-control input-readonly" placeholder="请选择适用包厢类型" v-model="bdpri_boxtype_txt" ref="bdpri_boxtype_txt" @click="bdpriBoxtypeFun($event)" readonly>
						<span class="selection_clear" @click="clear_input('bdpri_boxtype_txt')">×</span>
						<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">有效星期日:</label>
					<div class="col-md-9">
						<input class="form-control input-readonly" placeholder="请选择有效星期日" v-model="bdpri_week_txt" ref="bdpri_week_txt" @click="bdpriWeekFun($event)" readonly>
						<span class="selection_clear" @click="clear_input('bdpri_week_txt')">×</span>
						<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 control-label">可使用时间:</label>
					<div class="col-md-9">
						<input class="form-control input-readonly" placeholder="请选择可使用时间" v-model="bdpri_use_time" ref="bdpri_use_time" @click="bdpriTimeSel($event)" readonly>
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">包断金额:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入包厢费包断金额" v-model="bdpri_bd">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">会员包断金额:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="会员包断金额指会员使用会员卡支付时的包断金额" v-model="bdpri_vip_bd">
					</div>
				</div>
			</div>
			<div class="price-set-title">—————— 不同会员等级会员金额设置 ——————</div>
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 control-label">一级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level1_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">三级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level3_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">五级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level5_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">七级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level7_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">九级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level9_price">
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row">
					<label class="col-md-3 control-label">二级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level2_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">四级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level4_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">六级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level6_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">八级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level8_price">
					</div>
				</div>
				<div class="row">
					<label class="col-md-3 control-label">十级会员价:</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入金额" v-model="bd_vip_level10_price">
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 包断适用包厢类型选择 -->
	<div class="ele-hide" ref="bdpri_boxtype_area">
		<div class="goods_checkboxdiv">
			<ul class="roomarea">
				<li>
					<input type='checkbox' v-model='bdpri_boxtype_all' @click='bdpriBoxtypeAll'>
					<span>全选</span>
				</li>
				<li v-for="item in bdpri_boxtype_date">
					<input type="checkbox" v-model='bdpri_boxtype_item' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
	</div>
	<!-- 包断星期选择 -->
	<div class="ele-hide" ref="bdpri_week_area">
		<div class="goods_checkboxdiv">
			<ul class="roomarea">
				<li>
					<input type='checkbox' v-model='bdpri_week_all' @click='bdpriWeekAll'>
					<span>全选</span>
				</li>
				<li v-for="item in bdpri_week_date">
					<input type="checkbox" v-model='bdpri_week_item' :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</div>
	</div>
	<!-- 包断时间选择 -->
	<div id="chooseTime_popup" ref="bdpri_time_range">
		<div class="chooseTime_popup-wrap">
			<div class="chooseTime_popup_title">开始时间：</div>
			<select ref="bdpri_starthour"></select>
			<label class="colon">:</label>
			<select ref="bdpri_startseconds"></select>
			<div class="chooseTime_popup_title">结束时间：</div>
			<select ref="bdpri_stophour" id="stophour"></select>
			<label class="colon">:</label>
			<select ref="bdpri_stopseconds"></select>
		</div>
	</div>

	<!-- 包厢类型选择 -->
	<div class="ele-hide" ref="box_area">
		<div class="goods_checkboxdiv">
			<ul class="roomarea">
				<li v-for="item in box_checkboxdata">
				<input type="radio" name="shop_area" v-model='box_checkboxModel' :value="item.id">
				<span>{{item.name}}({{item.des}})</span>
				</li>
				<div style="clear:both;"></div>
			</ul>
		</div>
	</div>
	<!-- 星期选择 -->
	<div class="ele-hide" ref="week_area">
		<div class="goods_checkboxdiv">
			<ul class="roomarea">
				<li>
					<input type='checkbox' v-model='week_allcheck' @click='weekCheckedAll'>
					<span>全选</span>
				</li>
				<li v-for="item in validity_date">
					<input type="checkbox" v-model='validity_dateModel' :value="item.id">
					<span>{{item.name}}</span>
				</li>
				<div style="clear:both;"></div>
			</ul>
		</div>
	</div>
	<!-- 时间选择 -->
	<div id="chooseTime_popup" ref="chooseTime_popup">
		<div class="chooseTime_popup-wrap">
			<div class="chooseTime_popup_title">开始时间：</div>
			<select ref="starthour"></select>
			<label class="colon">:</label>
			<select ref="startseconds"></select>
			<div class="chooseTime_popup_title">结束时间：</div>
			<select ref="stophour" id="stophour"></select>
			<label class="colon">:</label>
			<select ref="stopseconds"></select>
		</div>
	</div>
	<!-- 计时开房详情 -->
	<div class="printer_detail details_content" v-show="showonlydetail">
		<div class="page_header">计时开房设置详情</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">适用门店：</label>
			<div class="col-md-5">{{theTiming.shop_name}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">优先级：</label>
			<div class="col-md-5">{{theTiming.listorder}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">适用包厢类型：</label>
			<div class="col-md-5">{{theTiming.room_type_name}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">有效星期日：</label>
			<div class="col-md-5">{{theTiming.validity_date_name}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">可使用时间：</label>
			<div class="col-md-5">{{theTiming.start_time}}-{{theTiming.end_time}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">计时单价：</label>
			<div class="col-md-5">{{theTiming.price}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">会员计时单价：</label>
			<div class="col-md-5">{{theTiming.vip_price}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">低消金额：</label>
			<div class="col-md-5">{{theTiming.min_consumption}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">会员低消金额：</label>
			<div class="col-md-5">{{theTiming.vip_min_consumption}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">酒水不满低消设置：</label>
			<div class="col-md-5" v-if="theTiming.minimum_type == '1'">收实际时间费</div>
			<div class="col-md-5" v-if="theTiming.minimum_type == '2'">收到低消的金额</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">包断金额：</label>
			<div class="col-md-5">{{theTiming.bd_price}}</div>
		</div>
		<div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 140px;">会员包断金额：</label>
			<div class="col-md-5">{{theTiming.bd_vip_price}}</div>
		</div>
		<!--div class="row rowpadding printer_detail_row">
			<label class="col-md-1 control-label" style="width: 120px;">跨时段是否续用：</label>
			<div class="col-md-5">{{(theTiming.cross_time=='1')?'是':'否'}}</div>
		</div-->
		<div class="price-set-title">—————— 不同会员等级会员金额设置 ——————</div>
		<div class="price-set-row">
			<div class="row-title">一级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level1_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level1_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level1_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">二级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level2_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level2_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level2_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">三级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level3_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level3_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level3_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">四级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level4_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level4_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level4_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">五级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level5_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level5_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level5_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">六级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level6_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level6_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level6_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">七级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level7_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level7_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level7_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">八级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level8_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level8_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level8_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">九级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level9_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level9_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level9_price}}</div>
			</div>
		</div>
		<div class="price-set-row">
			<div class="row-title">十级会员价：</div>
			<div class="item">
				<div class="txt">计时单价</div>
				<div class="price">{{theTiming.vip_level10_price}}</div>
			</div>
			<div class="item">
				<div class="txt">低消金额</div>
				<div class="price">{{theTiming.vip_level10_minimum_consumption}}</div>
			</div>
			<div class="item">
				<div class="txt">包断金额</div>
				<div class="price">{{theTiming.bd_vip_level10_price}}</div>
			</div>
		</div>

		<div class="row" style="padding-top: 30px;">
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
		</div>
	</div>
</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'timing_manage',
	data() {
		return {
			showlist: true,
			showdetail: false,
			showonlydetail: false,
			showbdpri: false,
			addorupdate: 1,
			list_menu_add: false,
			list_menu_op: [],
			theTiming: {
				type: Object
			},
			room_type_name: "",
			initBoxData: "",
			timing_listorder: '', // 优先级
			timing_room_type: "",
			selectdata: [],
			add_header: "添加计时开房设置",
			box_checkboxModel: "",
			box_checkboxdata: [],

			showBox: false,
			edit_box: '',
			edit_all_box: '',
			box_all: false,
			c_box_all: false,
			box_item: [],
			c_box_item: [],
			box_floor: [],
			c_box_floor: [],
			box_arr: [],
			box_arr_det: [],

			week_allcheck: false,
			c_week_allcheck: false,
			validity_date_name: "",
			validity_date: [{
				id: 1,
				name: "星期一"
			},{
				id: 2,
				name: "星期二"
			},{
				id: 3,
				name: "星期三"
			},{
				id: 4,
				name: "星期四"
			},{
				id: 5,
				name: "星期五"
			},{
				id: 6,
				name: "星期六"
			},{
				id: 0,
				name: "星期日"
			}],
			validity_dateModel: [],
			editstart_time: "00:00",
			editend_time: "00:00",
			edit_use_time: "00:00-00:00",
			time_cost_price: "",
			vip_cost_price: "",
			lowest_cost_price: "",
			viplowest_cost_price: "",
			box_cost_price: "",
			vipbox_cost_price: "",
			intertemporal: -1,
			relation_id: [],
			rule_name: '',
			rule_time_range: '',
			rule_time_start: '',
			rule_time_end: '',
			rule_price: '',
			rule_vip_price: '',
			rule_min: '',
			rule_vip_min: '',
			rule_bd: '',
			rule_vip_bd: '',
			rule_diffrent_vip_price: [],

			vip_level1_price: '',
			vip_level2_price: '',
			vip_level3_price: '',
			vip_level4_price: '',
			vip_level5_price: '',
			vip_level6_price: '',
			vip_level7_price: '',
			vip_level8_price: '',
			vip_level9_price: '',
			vip_level10_price: '',
			vip_level1_minimum_consumption: '',
			vip_level2_minimum_consumption: '',
			vip_level3_minimum_consumption: '',
			vip_level4_minimum_consumption: '',
			vip_level5_minimum_consumption: '',
			vip_level6_minimum_consumption: '',
			vip_level7_minimum_consumption: '',
			vip_level8_minimum_consumption: '',
			vip_level9_minimum_consumption: '',
			vip_level10_minimum_consumption: '',
			bd_vip_level1_price: '',
			bd_vip_level2_price: '',
			bd_vip_level3_price: '',
			bd_vip_level4_price: '',
			bd_vip_level5_price: '',
			bd_vip_level6_price: '',
			bd_vip_level7_price: '',
			bd_vip_level8_price: '',
			bd_vip_level9_price: '',
			bd_vip_level10_price: '',

			bdpri_modify: '1',
			bdpri_boxtype_all: false,
			c_bdpri_boxtype_all: false,
			bdpri_boxtype_date: [],
			bdpri_boxtype_item: [],
			bdpri_boxtype_txt: '',
			bdpri_week_all: false,
			c_bdpri_week_all: false,
			bdpri_week_date: [{
				id: 1,
				name: "星期一"
			},{
				id: 2,
				name: "星期二"
			},{
				id: 3,
				name: "星期三"
			},{
				id: 4,
				name: "星期四"
			},{
				id: 5,
				name: "星期五"
			},{
				id: 6,
				name: "星期六"
			},{
				id: 0,
				name: "星期日"
			}],
			bdpri_week_item: [],
			bdpri_week_txt: '',
			bdpri_use_time: '',
			bdpri_start_time: '',
			bdpri_end_time: '',
			bdpri_bd: '',
			bdpri_vip_bd: '',
		}
	},
	filters: {
		formatIndex: function(val) {
			var levelName = '一二三四五六七八九十'
			return levelName.charAt(val)
		},
	},
	watch: {
		timing_room_type: {
		    handler: function(val, oldval) {
		    	if(val != "") {
					$(this.$refs.timing_room_type).parent().find('.selection_clear').show();
					$(this.$refs.edit_box).prop('disabled', false);
		    	} else {
					$(this.$refs.timing_room_type).parent().find('.selection_clear').hide();
					$(this.$refs.edit_box).prop('disabled', true);
					this.edit_box = '';
					this.box_item = [];
		    	}
		    },
		    deep: true
		},
		validity_date_name: {
		    handler: function(val,oldval) {
		    	if(val != "") {
		    		$(this.$refs.validity_date_name).parent().find('.selection_clear').show();
		    	} else {
		    		$(this.$refs.validity_date_name).parent().find('.selection_clear').hide();
		    	}
		    },
		    deep: true
		},
		validity_dateModel: {
		    handler: function (val, oldVal) {
		        if(this.validity_dateModel.length >= this.validity_date.length) {
		            this.week_allcheck = true;
		            this.c_week_allcheck = true;
		        } else {
		            this.week_allcheck = false;
		            this.c_week_allcheck = false;
		        }
		    },
		    deep: true
		},
		edit_box: {
			handler: function(val, oldval) {
				if(val != "") {
					$(this.$refs.edit_box).parent().find('.selection-clear').show();
				} else {
					$(this.$refs.edit_box).parent().find('.selection-clear').hide();
				}
			},
			deep: true
		},
		box_item: {
			handler: function(val, oldVal) {
				let _this = this;

				if(_this.box_item.length >= _this.box_arr_det.length) {
					_this.box_all = true;
					_this.c_box_all = _this.box_all;
				} else {
					_this.box_all = false;
					_this.c_box_all = _this.box_all;
				}

				$.each(_this.box_arr, function(k, v) {
					if(_this.box_item.length >= v.room.length) {
						let num = 0;
						for(let i = 0, len = v.room.length; i < len; i++) {
							if(_this.box_item.indexOf(v.room[i].id) != -1) {
								num++;
							}
							if(i == v.room.length - 1 && num == v.room.length) {
								if(_this.box_floor.indexOf(v.room_area) == -1) {
									_this.box_floor.push(v.room_area);
								}
							} else {
								let index = '';
								index = _this.box_floor.indexOf(v.room_area);
								if(index != -1) {
									_this.box_floor.splice(index, 1);
								}
							}
						}
					} else {
						let index = '';
						index = _this.box_floor.indexOf(v.room_area);
						if(index != -1) {
							_this.box_floor.splice(index, 1);
						}
					}
				});
				_this.c_box_floor = _this.box_floor;
			},
			deep: true
		},

		bdpri_boxtype_txt: {
			handler: function(val,oldval) {
				if(val != "") {
					$(this.$refs.bdpri_boxtype_txt).parent().find('.selection_clear').show();
				} else {
					$(this.$refs.bdpri_boxtype_txt).parent().find('.selection_clear').hide();
				}
			},
			deep: true
		},
		bdpri_boxtype_item: {
			handler: function(val, oldVal) {
				if(this.bdpri_boxtype_item.length >= this.bdpri_boxtype_date.length) {
					this.bdpri_boxtype_all = true;
					this.c_bdpri_boxtype_all = true;
				} else {
					this.bdpri_boxtype_all = false;
					this.c_bdpri_boxtype_all = false;
				}
			},
			deep: true
		},

		bdpri_week_txt: {
			handler: function(val,oldval) {
				if(val != "") {
					$(this.$refs.bdpri_week_txt).parent().find('.selection_clear').show();
				} else {
					$(this.$refs.bdpri_week_txt).parent().find('.selection_clear').hide();
				}
			},
			deep: true
		},
		bdpri_week_item: {
			handler: function(val, oldVal) {
				if(this.bdpri_week_item.length >= this.bdpri_week_date.length) {
					this.bdpri_week_all = true;
					this.c_bdpri_week_all = true;
				} else {
					this.bdpri_week_all = false;
					this.c_bdpri_week_all = false;
				}
			},
			deep: true
		},
	},
	mounted: function() {
		this.getMenuOp();
		this.$nextTick(function() {
			let _this = this;
			this.getshopdata();
			
			$(this.$refs.drink_get_type).select2({
				minimumResultsForSearch: -1,
				language: "zh-CN"
			});
			this.initTimeRange();
		});
	},
    methods: {
		// 获取权限
		getMenuOp() {
			let _this = this,
				menu = [];
			if(!$.isEmptyObject(this.$store.state.menunew)) {
				menu = JSON.parse(this.$store.state.menunew);
				$.each(menu, function(k, v) {
					if(v.id == '542') {
						menu = v.submenu;
						$.each(menu, function(m, n) {
							if(n.id == '553') {
								menu = n.submenu;
							}
						});
					}
				});

				_this.list_menu_op = [{cls: 'text-blue detail', name: '详情'}];
				$.each(menu, function(x, y) {
					if(y.id == '924') {
						_this.list_menu_add = true;
					}
					if(y.id == '925') {
						_this.list_menu_op.push({cls: 'text-blue update', name: '修改'});
					}
					if(y.id == '926') {
						_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
					}
				});
			}
		},
		initi_add_shop_name: function() {
			let _this = this;
			let selectdata = this.selectdata;
			$(_this.$refs.add_shop_name).html("");
			$(_this.$refs.add_shop_name).select2({
				data: selectdata,
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			}).on("select2:select", function(e) {
				_this.timing_room_type = "";
				$(_this.$refs.timing_room_type).removeClass("canselect");
			});
		},
        // 获取时间
		init_selectTime: function() {
			let _this = this;
			let seconds = [];
			for(let i = 0; i < 60; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				seconds[i] = item;
			};
			let hour = [];
			for(let i = 0; i < 24; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				hour[i] = item;
			}
			$(_this.$refs.starthour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.startseconds).select2({
				data: seconds,
				language: "zh-CN"
			});
			$(_this.$refs.stophour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.stopseconds).select2({
				data: seconds,
				language: "zh-CN"
			})
		},
		getshopdata: function() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl+"PublicData/api_getShopListByPurview",
				crossDomain: true,
				xhrFields: {
				withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						let arr = []
						$.each(data.response.result, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.timing_shop_input).select2({
							data: arr,
							language: "zh-CN"
						}).on("select2:select", function(e) {
							if(e.params.data.text == "全部") {
								$(_this.$refs.list_box_type).val("").trigger('change');
								$(_this.$refs.list_box_type).prop("disabled", true);
								return;
							}
							$(_this.$refs.list_box_type).prop("disabled", false);
							_this.getboxdata(e.params.data.id, '1');
						});
						$(_this.$refs.timing_shop_input).val(data.response.result[1].id).trigger('change');
						$(_this.$refs.list_box_type).prop("disabled", false);
						_this.getboxdata(data.response.result[1].id, '1');
						_this.innitable();

						_this.selectdata = arr;

						arr.shift();
						$(_this.$refs.bdpri_sel_shop).select2({
							data: arr,
							language: "zh-CN",
							width: '100%'
						}).on("select2:select", function(e) {
							_this.getboxdata(e.params.data.id, '3');
						});
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {}
			});
		},
		getboxdata: function(shop_id, type) {
			let _this = this;
			// var boxdatas = [{ id:" ", text: "全部" }];
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": shop_id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "PublicData/api_getRoomType",
				async:false,
				crossDomain: true,
				xhrFields: {
				withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						if(type == '2') {
							_this.box_checkboxdata = data['response']['result']['data'];
							return;
						}
						let arr = [{id: ' ', text: '全部'}];
						$.each(data.response.result.data, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						if(type == '1') {
							$(_this.$refs.list_box_type).html('');
							$(_this.$refs.list_box_type).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							});
						} else if(type == '3') {
							$(_this.$refs.bdpri_sel_type).html('');
							$(_this.$refs.bdpri_sel_type).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							});
						}
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
				}
			});
		},
		// 点击“查询”按钮
		queryList: function() {
			this.innitable();
		},
		innitable: function() {
			var _this = this;
			var actionEvents = {
				'click .update': function(e, value, row, index) {
					_this.initi_add_shop_name();
					_this.addorupdate = 2;
					_this.getTimingDetail(row.id, 'update');
					_this.showlist = false;
					_this.showdetail = true;
					_this.showonlydetail = false;
					_this.add_header = "修改计时开房设置";
					_this.relation_id = row.id;
					_this.initRuleTable();
				},
				'click .detail': function(e, value, row, index) {
					_this.showlist = false;
					_this.showdetail = false;
					_this.showonlydetail = true;
					_this.addorupdate = 3;
					_this.getTimingDetail(row.id, '');
				},
				'click .del': function(e, value, row, index) {
					layer.confirm('删除后不可恢复，确定删除吗？', {
						btn: ['确定', '取消'] //按钮
					}, function() {
						_this.delTiming(row.id);
					});
				}
			};
			$(this.$refs.timing_manage_table).bootstrapTable("destroy");
			$(this.$refs.timing_manage_table).bootstrapTable({
				pageSize: 10,
				pageList: [],
				ajax: function(params) {
					_this.gettiminglistdata(params);
				},
				sidePagination: "server",
				pagination: true,
				columns: [{
					width: "8%",
					field: "shop_name",
					title: "门店"
				}, {
					width: "5%",
					field: "listorder",
					title: "优先级"
				}, {
					width: "8%",
					field: "room_type_name",
					title: "适用包厢类型"
				}, {
					width: "8%",
					field: "room_names",
					title: "包厢号",
					formatter: function(value, row, index) {
						if(row.all_rooms == '1') {
							return '全部包厢';
						} else {
							return value;
						}
					}
				}, {
					width: "15%",
					field: "week_cycle",
					title: "有效星期日"
				}, {
					width: "8%",
					field: "use_time",
					title: "可使用时间",
					formatter: function(value, row, index) {
						return row.start_time + "-" + row.end_time;
					}
				}, {
					width: "8%",
					field: "price",
					title: "计时单价/小时"
				}, {
					width: "8%",
					field: "min_consumption",
					title: "低消金额"
				},{
					width: "15%",
					title: "操作",
					events: actionEvents,
					formatter: function(value) {
						let op_html = '';
						$.each(_this.list_menu_op, function(k, v) {
							op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
						});
						return op_html;
					}
				}],
			});
		},
		gettiminglistdata: function(params) {
			var _this = this;
			var pageNumber = 1;
			if(params.data.offset != 0) {
				pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
			}
			var layIndex = layer.load(0, {
				shade: [0.1, '#ececec']
			});
			var datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"page": pageNumber,
						"page_size": params.data.limit,
						"shop_id": $.trim($(_this.$refs.timing_shop_input).val()),
						"room_type": $.trim($(_this.$refs.list_box_type).val()),
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "roomTiming/getList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code']=="true"){
						params.success({
							total: data['response']['result']['count'],
							rows: data['response']['result']['list']
						});
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
						params.success({
							total: 0,
							rows: []
						});
					}
					layer.close(layIndex);
				},
				error: function(err) {
					layer.close(layIndex);
				}
			});
		},
		add_timing_page: function() {
			this.showlist = false;
			this.showdetail = true;
			this.showonlydetail = false;
			this.initi_add_shop_name();
			this.validity_dateModel = [];
			this.edit_use_time="00:00-00:00";
			this.editstart_time = "00:00";
			this.editend_time = "00:00";
			this.timing_listorder = "";
			this.time_cost_price = "";
			this.vip_cost_price = "";
			this.lowest_cost_price = "";
			this.viplowest_cost_price = "";
			this.box_cost_price = "";
			this.vipbox_cost_price = "";
			this.box_checkboxModel = "";
			this.validity_date_name = "";
			$(this.$refs.starthour).val("00:00").trigger("change");
			$(this.$refs.startseconds).val("00:00").trigger("change");
			$(this.$refs.stophour).val("00:00").trigger("change");
			$(this.$refs.stopseconds).val("00:00").trigger("change");
			this.init_selectTime();
			this.addorupdate = 1;
			this.add_header = "添加计时开房设置";

			$(this.$refs.drink_get_type).val('2').trigger('change');

			$(this.$refs.add_shop_name).prop("disabled", false);
			$(this.$refs.add_shop_name).val(this.selectdata[0].id).trigger('change');
			this.timing_room_type = "";
			$(this.$refs.timing_room_type).removeClass("canselect");
			this.edit_box = '';
			this.edit_all_box = '-1';
			this.box_item = [];
			for(var i = 1; i <= 10; i ++) {
				this[`vip_level${i}_price`] = ''
				this[`vip_level${i}_minimum_consumption`] = ''
				this[`bd_vip_level${i}_price`] = ''
			}
		},
		// 返回
		backFun: function() {
			this.showonlydetail = false;
			this.showdetail = false;
			this.showbdpri = false;
			this.showlist = true;
			// (mark==1)?$(this.$refs.timing_manage_table).bootstrapTable('refreshOptions',{pageNumber:1}): (mark==3)?"":$(this.$refs.timing_manage_table).bootstrapTable('refresh');
		},
		// 修改页的提示语
		hint_language:function(e) {
			var contents="<span class='dots'>·</span>"+$(e.currentTarget).attr("titles");
			layer.tips(contents, $(e.currentTarget), {
				skin: 'hint_language_tip',
				tips: [2, '#fff'],
				time: 2000000,
			});
		},
		// 关闭提示语
		close_hint_language:function() {
			layer.closeAll('tips');
		},
		// 清空
		clear_input: function(name) {
			if(name == "timing_room_type") {
				this.timing_room_type = "";
				this.box_checkboxModel = "";
			} else if(name == "validity_date_name") {
				this.validity_date_name = "";
				this.validity_dateModel = [];
			} else if(name == "bdpri_boxtype_txt") {
				this.bdpri_boxtype_txt = "";
				this.bdpri_boxtype_item = [];
			} else if(name == "bdpri_week_txt") {
				this.bdpri_week_txt = "";
				this.bdpri_week_item = [];
			}
		},
		room_type_fun: function(e) {
			let _this = this;
			if(!$(e.currentTarget).hasClass('canselect')) {
				let shopid = $(this.$refs.add_shop_name).val();
				this.getboxdata(shopid, '2');
				layer.confirm('', {
					skin: 'timing_room_type',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['包厢类型', true],
					area: ['450px', ''], // 宽高
					content: $(this.$refs.box_area),
				}, function() {
					_this.box_checkboxdata.forEach(function(item) {
						if(item.id == _this.box_checkboxModel){
							_this.timing_room_type = item.name;
						}
					});
					// 包厢号全选
					_this.getBoxNum();
					_this.box_item = [];
					_this.box_arr_det.forEach(function(item) {
						_this.box_item.push(item.id);
					});
					_this.edit_box = '全部包厢';
					_this.edit_all_box = '1';

					layer.closeAll();
				});
			}
		},
		// 点击选择包厢号
		editBoxFun: function() {
			this.c_box_item = this.box_item;
			this.showdetail = false;
			this.showBox = true;
		},
		// 包厢号数据
		getBoxNum: function() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": $(_this.$refs.add_shop_name).val(),
						"room_type": _this.box_checkboxModel
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "Shop/getAllRoomByArea",
				async: false,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.box_arr = data['response']['result'];
						let newarray = [];
						$.each(data['response']['result'], function(k, v) {
							$.each(v.room, function(m, n) {
								newarray.push(n);
							});
						});
						_this.box_arr_det = newarray;
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {}
			});
		},
		// 全选
		boxAll: function() {
			let _this = this;
			_this.box_all = _this.c_box_all;
			if(!_this.box_all) { // 实现全选
				_this.box_item = [];
				_this.box_arr_det.forEach(function(item) {
					_this.box_item.push(item.id);
				});
			} else { // 实现反选
				_this.box_item = [];
			}
		},
		// 楼层全选/反选
		boxFloor: function(id, index) {
			let _this = this;

			_this.box_floor = _this.c_box_floor;
			if(_this.box_floor.indexOf(id) == -1) {
				$.each(_this.box_arr[index].room, function(k, v) {
					if(_this.box_item.indexOf(v.id) == -1) {
						_this.box_item.push(v.id);
					}
				});
			} else {
				$.each(_this.box_arr[index].room, function(k, v) {
					let index = '';
					index = _this.box_item.indexOf(v.id);
					if(index != -1) {
						_this.box_item.splice(index, 1);
					}
				});
			}
		},
		// 清空包厢号
		clearInput: function(name) {
			this.edit_box = '';
			this.edit_all_box = '-1';
			this.box_item = [];
		},
		// 确定包厢
		saveBox: function() {
			const _this = this;

			if(_this.box_arr_det.length === _this.box_item.length) {
				_this.edit_box = '全部包厢';
				_this.edit_all_box = '1';
			} else {
				let texts = [];
				_this.box_arr_det.forEach(function(item) {
					_this.box_item.forEach(function(sub) {
						if(item.id == sub) {
							texts.push(item.name);
						}
					});
				});
				_this.edit_box = texts.join(",");
				_this.edit_all_box = '-1';
			}
			_this.showdetail = true;
			_this.showBox = false;
		},
		// 返回
		boxBackEdit: function() {
			this.box_item = this.c_box_item;
			this.showdetail = true;
			this.showBox = false;
		},
		week_data_fun: function(e) {
			if(!$(e.currentTarget).hasClass('canselect')) {
				let _this = this;
				let c_validity_dateModel = _this.validity_dateModel;
				layer.confirm('', {
					skin: 'timing_room_type',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['有效星期日', true],
					content: $(this.$refs.week_area),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.validity_date_name != "") {
                            _this.validity_dateModel = c_validity_dateModel;
                            return;
                        }
                        _this.validity_dateModel = [];
                    }
				}, function() {
					var texts = [];
					_this.validity_date.forEach(function(item) {
						_this.validity_dateModel.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.validity_date_name = texts.join(",");
					layer.closeAll();
				}, function() {
                    if(_this.validity_date_name != "") {
                        _this.validity_dateModel = c_validity_dateModel;
                        return;
                    }
                    _this.validity_dateModel = [];
                });
			}
		},
		// 全选
		weekCheckedAll: function() {
			var _this = this;
			_this.week_allcheck = _this.c_week_allcheck;
			if(!_this.week_allcheck) { // 实现全选
				_this.validity_dateModel = [];
				_this.validity_date.forEach(function(item) {
					_this.validity_dateModel.push(item.id);
				});
			} else { // 实现反选
				_this.validity_dateModel = [];
			}
		},
		chooseTimePop: function() {
			var _this = this;
			$(_this.$refs.starthour).val(_this.editstart_time.split(':')[0]).trigger('change');
			$(_this.$refs.startseconds).val(_this.editstart_time.split(':')[1]).trigger('change');
			$(_this.$refs.stophour).val(_this.editend_time.split(':')[0]).trigger('change');
			$(_this.$refs.stopseconds).val(_this.editend_time.split(':')[1]).trigger('change');
			layer.confirm('', {
				type: 1,
				btn: ['确定', '取消'], //按钮
				title: '使用时间选择',
				area: ['450px', ''], //宽高
				content:$(this.$refs.chooseTime_popup),
			}, function() {
				_this.createTimeString();
				layer.closeAll();
			});
		},
		createTimeString: function() {
			var _this = this;
			var starthour = $(_this.$refs.starthour).select2("val");
			var startseconds = $(_this.$refs.startseconds).select2("val");
			var stophour = $(_this.$refs.stophour).select2("val");
			var stopseconds = $(_this.$refs.stopseconds).select2("val");
			_this.editstart_time = starthour + ":" + startseconds;
			_this.editend_time = stophour + ":" + stopseconds;
			_this.edit_use_time=_this.editstart_time+"-"+_this.editend_time;
		},
		add_update_roomtiming:function(status){
			var _this = this;
			var datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"room_type":this.box_checkboxModel,
						"listorder": this.timing_listorder,
						"room_type_name": this.timing_room_type,
						"room_ids": this.box_item,
						"all_rooms": this.edit_all_box,
						"shop_id": $(this.$refs.add_shop_name).val(),
						"shop_name":$(this.$refs.add_shop_name).find("option:selected").text(),
						"week_cycle": this.validity_dateModel,
						"price": this.time_cost_price,
						"vip_price": this.vip_cost_price,
						"min_consumption": this.lowest_cost_price,
						"vip_min_consumption":this.viplowest_cost_price,
						"bd_price": this.box_cost_price,
						"bd_vip_price": this.vipbox_cost_price,
						"start_time": this.editstart_time,
						"end_time": this.editend_time,
						"minimum_type": $(_this.$refs.drink_get_type).val()
						//"cross_time":this.intertemporal,
					}
				},
				"comment": ""
			};
			// 不同等级会员价格
			for(var i = 0; i <= 10; i ++) {
				datas.request.param[`vip_level${i}_price`] = this[`vip_level${i}_price`]
				datas.request.param[`vip_level${i}_minimum_consumption`] = this[`vip_level${i}_minimum_consumption`]
				datas.request.param[`bd_vip_level${i}_price`] = this[`bd_vip_level${i}_price`]
			}

			(status=="1")?"":datas["request"]["param"]["id"]=_this.theTiming.id;
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl+"roomTiming/edit",
				crossDomain: true,
				xhrFields: {
				withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						layer.msg(data["response"]["error_msg"]);
						_this.showlist=true;
						_this.showdetail=false;
						$(_this.$refs.timing_manage_table).bootstrapTable("refresh");
						// _this.innitable();
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						if(data.response.result_status == "99") {
							layer.alert('', {
								title:'重复提示',
								skin: 'layer-repetition',
								content:'<p class="tip">以下时间重复,请重新设置</p><p class="tipcont">'+data.response.error_msg+'</p>'
							});
							return;
						}
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {

				}
			});
		},
		// 详情
		getTimingDetail: function(id, type) {
			var _this=this;
			var datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"id": id || "",
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "roomTiming/getDetail",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code']=="true") {
						var datas = data['response']['result'];
						var week_cycle = datas.week_cycle;
						var texts = [];
						_this.validity_date.forEach(function(item) {
							week_cycle.forEach(function(item2) {
								if(item.id == item2) {
									texts.push(item.name);
								}
							});
						});
						var validity_date_name = texts.join(",");
						_this.theTiming = datas;
						_this.theTiming['validity_date_name'] = validity_date_name;
						if(type == "update") {
							$(_this.$refs.add_shop_name).val(datas.shop_id).trigger("change");
							$(_this.$refs.add_shop_name).prop("disabled", true);
							_this.timing_listorder = datas.listorder;
							_this.timing_room_type = datas.room_type_name;
							_this.box_checkboxModel = datas.room_type;
							$(_this.$refs.timing_room_type).removeClass("canselect");
							_this.getBoxNum();
							_this.edit_all_box = datas.all_rooms;
							if(_this.edit_all_box == '1') {
								_this.edit_box = '全部包厢';
								_this.box_item = [];
								_this.box_arr_det.forEach(function(item) {
									_this.box_item.push(item.id);
								});
							} else {
								_this.edit_box = datas.room_names;
								_this.box_item = datas.room_ids;
							}
							_this.validity_dateModel = week_cycle;
							_this.validity_date_name = validity_date_name;
							_this.edit_use_time = datas.start_time + "-" + datas.end_time;
							_this.editstart_time = datas.start_time;
							_this.editend_time = datas.end_time;
							// 时间
							var starthour_set = datas.start_time.split(":")[0];
							if(datas.start_time.split(":")[0].split("0")[0] == "") {
								starthour_set = datas.start_time.split(":")[0].split("0")[1];
								if(datas.start_time.split(":")[0].split("0")[1] == "") {
									starthour_set = "0";
								}
							}
							var startseconds_set = datas.start_time.split(":")[1];
							if(datas.start_time.split(":")[1].split("0")[0] == "") {
								startseconds_set = datas.start_time.split(":")[1].split("0")[1];
								if(datas.start_time.split(":")[1].split("0")[1] == "") {
									startseconds_set = "0";
								}
							}
							var stophour_set = datas.end_time.split(":")[0];
							if(datas.end_time.split(":")[0].split("0")[0] == "") {
								stophour_set = datas.end_time.split(":")[0].split("0")[1];
								if(datas.end_time.split(":")[0].split("0")[1] == "") {
									stophour_set = "0";
								}
							}
							var stopseconds_set = datas.end_time.split(":")[1];
							if(datas.end_time.split(":")[1].split("0")[0] == "") {
								stopseconds_set = datas.end_time.split(":")[1].split("0")[1];
								if(datas.end_time.split(":")[1].split("0")[1] == "") {
									stopseconds_set = "0";
								}
							}
							_this.init_selectTime();
							$(_this.$refs.starthour).val(starthour_set).trigger("change");
							$(_this.$refs.startseconds).val(startseconds_set).trigger("change");
							$(_this.$refs.stophour).val(stophour_set).trigger("change");
							$(_this.$refs.stopseconds).val(stopseconds_set).trigger("change");
							_this.time_cost_price=datas.price;
							_this.vip_cost_price=datas.vip_price;
							_this.lowest_cost_price=datas.min_consumption;
							_this.viplowest_cost_price=datas.vip_min_consumption;
							_this.box_cost_price = datas.bd_price;
							_this.vipbox_cost_price = datas.bd_vip_price;

							// 不同会员等级价格
							for(var i = 0; i <= 10; i++) {
								_this[`vip_level${i}_price`] = datas[`vip_level${i}_price`];
								_this[`vip_level${i}_minimum_consumption`] = datas[`vip_level${i}_minimum_consumption`];
								_this[`bd_vip_level${i}_price`] = datas[`bd_vip_level${i}_price`];
							}

							$(_this.$refs.drink_get_type).val(datas.minimum_type).trigger('change');
							//_this.intertemporal=datas.cross_time;
						}
					} else {
						Vue.timeoutfun(data.response.result_status,_this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
				}
			});
		},
		// 删除
		delTiming: function(id) {
			let _this = this;
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"id": id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "roomTiming/delRoomTiming",
				async: true,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						layer.msg(data["response"]["error_msg"]);
						$(_this.$refs.timing_manage_table).bootstrapTable("refresh");
						// _this.innitable();
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {

				}
			});
		},

		// 初始化节假日计时设置
		initRuleTable: function() {
			let _self = this;
			$(_self.$refs.rule_list).bootstrapTable('destroy');
			$(_self.$refs.rule_list).bootstrapTable({
				pageNumber: 1,
				pageSize: 10,
				pagination: true,
				ajax: function(params) {
					_self.getRuleList(params);
				},
				sidePagination: "server",
				columns: [{
					field: "name",
					title: "节假日名称",
					width: "10%",
					valign: "middle"
				}, {
					field: "enable_start_time",
					title: "适用日期",
					width: "15%",
					valign: "middle",
					formatter: function(value, row, index) {
						return row.enable_start_time + ' ~ ' + row.enable_end_time;
					}
				}, {
					field: "price",
					title: "计时单价",
					width: "10%",
					valign: "middle"
				}, {
					field: "vip_price",
					title: "会员计时单价",
					width: "10%",
					valign: "middle"
				}, {
					field: "minimum_consumption",
					title: "低消金额",
					width: "10%",
					valign: "middle"
				}, {
					field: "vip_minimum_consumption",
					title: "会员低消金额",
					width: "10%",
					valign: "middle"
				}, {
					field: "bd_price",
					title: "包断金额",
					width: "10%",
					valign: "middle"
				}, {
					field: "bd_vip_price",
					title: "会员包断金额",
					width: "10%",
					valign: "middle"
				}, {
					title: "操作",
					width: "13%",
					valign: "middle",
					events: {
						'click .edit': function(e, value, row) {
							_self.rule_name = row.name;
							_self.rule_time_range = row.enable_start_time + ' ~ ' + row.enable_end_time;
							_self.rule_time_start = row.enable_start_time;
							_self.rule_time_end = row.enable_end_time;
							_self.rule_price = row.price;
							_self.rule_vip_price = row.vip_price;
							_self.rule_min = row.minimum_consumption;
							_self.rule_vip_min = row.vip_minimum_consumption;
							_self.rule_bd = row.bd_price;
							_self.rule_vip_bd = row.bd_vip_price;
							_self.rule_diffrent_vip_price = []
							for(var i = 1; i <= 10; i ++) {
								_self.rule_diffrent_vip_price.push({
									[`vip_level${i}_price`]: row[`vip_level${i}_price`],
									[`vip_level${i}_minimum_consumption`]: row[`vip_level${i}_minimum_consumption`],
									[`bd_vip_level${i}_price`]: row[`bd_vip_level${i}_price`]
								})
							}
							_self.ruleEdit('2', row.id);
						},
						'click .del': function(e, value, row) {
							layer.confirm('删除后【'+ row.name +'】将失效，确定删除吗？', {
								btn: ['确定', '取消'] //按钮
							}, function() {
								_self.delRule(row.id);
							});
						}
					},
					formatter: function(value, row, index) {
						return [
							'<div class="blue-wrap">',
							'<span class="edit">修改</span>&nbsp;&nbsp;&nbsp;&nbsp;',
							'<span class="del">删除</span>',
							'</div>'
						].join('');
					}
				}]
			});
		},
		// 获取节假日计时设置
		getRuleList: function(params) {
			let _self = this,
				pageNumber = 1;
			if(params != "" && params.data.offset != 0) {
				pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
			}
			let datas = {
				"header": Vue.request_header,
				"request": {
					"version": Vue.version,
					"param": {
						"page": pageNumber,
						"page_size": params.data.limit,
						"relation_id": _self.relation_id
					}
				},
				"comment": ""
			};
			let datas2 = JSON.stringify(datas);
			$.ajax({
				type: "post",
				dataType: "json",
				url: Vue.ctUrl + "roomTiming/getTimingHolidayList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: {
					json: datas2
				},
				success: function(data) {
					if(data.response.result_code == "true") {
						params.success({
							total: data.response.result.total,
							rows: data.response.result.rows
						});
					} else {
						Vue.timeoutfun(data.response.result_status, _self);
						layer.msg(data.response.error_msg);
						params.success({
							total: 0,
							rows: 0
						});
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		// 日期范围
		initTimeRange: function() {
			let _self = this;
			$(_self.$refs.rule_time_wrap).daterangepicker({
				timePicker: true,
				timePickerIncrement: 1,
				timePicker12Hour: false,
				buttonClasses: ['btn btn-default'],
				applyClass: 'btn-small btn-orange',
				cancelClass: 'btn-small btn-gray'
			}, function(start, end, label) {
				_self.rule_time_range = start.format('YYYY-MM-DD HH:mm') + ' ~ ' + end.format('YYYY-MM-DD HH:mm');
				_self.rule_time_start = start.format('YYYY-MM-DD HH:mm');
				_self.rule_time_end = end.format('YYYY-MM-DD HH:mm');
			});
		},
		// 点击新增
		addRule: function() {
			this.rule_name = '';
			this.rule_time_range = '';
			this.rule_time_start = '';
			this.rule_time_end = '';
			this.rule_price = '';
			this.rule_vip_price = '';
			this.rule_min = '';
			this.rule_vip_min = '';
			this.rule_bd = '';
			this.rule_vip_bd = '';
			this.rule_diffrent_vip_price = [];
			for(var i = 1; i <= 10; i ++) {
				this.rule_diffrent_vip_price.push({
					[`vip_level${i}_price`]: '',
					[`vip_level${i}_minimum_consumption`]: '',
					[`bd_vip_level${i}_price`]: ''
				})
			}
			this.ruleEdit('1', '');
			
		},
		ruleEdit: function(num, id) {
			let _self = this;
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['节假日计时设置', true],
                area: ['1100px', '700px'], // 宽高
                content: $(_self.$refs.rule_edit),
                offset: '100px'
            }, function() {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "relation_id": _self.relation_id, // 计时开房设置id
							"name": _self.rule_name, // 节假日名称
							"enable_start_time": _self.rule_time_start, // 适用开始时间
							"enable_end_time": _self.rule_time_end, // 适用结束时间
							"price": _self.rule_price, // 单价
							"vip_price": _self.rule_vip_price, // 会员单价
							"minimum_consumption": _self.rule_min, // 抵消
							"vip_minimum_consumption": _self.rule_vip_min, // 会员抵消
							"bd_price": _self.rule_bd, // 包断金额
							"bd_vip_price": _self.rule_vip_bd // 会员包断金额
                        }
                    },
                    "comment": ""
                };
                for(var i = 1; i <= 10; i ++) {
                	datas.request.param[`vip_level${i}_price`] = _self.rule_diffrent_vip_price[i-1][`vip_level${i}_price`]
                	datas.request.param[`vip_level${i}_minimum_consumption`] = _self.rule_diffrent_vip_price[i-1][`vip_level${i}_minimum_consumption`]
                	datas.request.param[`bd_vip_level${i}_price`] = _self.rule_diffrent_vip_price[i-1][`bd_vip_level${i}_price`]
                }
                let url = '';
                if(num == 1) {
                    url = Vue.ctUrl + "roomTiming/addTimingHoliday";
                } else if(num == 2) {
                    datas["request"]["param"]["id"] = id;
                    url = Vue.ctUrl + "roomTiming/updateTimingHoliday";
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('操作成功');
                            $(_self.$refs.rule_list).bootstrapTable('refresh');
                            // _self.initTypesTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _self);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
		},
		// 删除
		delRule: function(id) {
			let _this = this;
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"id": id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "roomTiming/delTimingHoliday",
				async: true,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						layer.msg('删除成功');
						$(_this.$refs.rule_list).bootstrapTable("refresh");
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg('出错啦');
				}
			});
		},
		// 打开包断管理
		openBdpri: function() {
			this.showlist = false;
			this.showbdpri = true;
			$(this.$refs.bdpri_sel_shop).val('').trigger('change');
			this.getboxdata($(this.$refs.bdpri_sel_shop).val(), '3');
			this.initBdpriTable();
			this.getBdPriShop();
			this.initBdpriTime();
		},
		// 初始化包断
		initBdpriTable: function() {
			let _this = this;
			$(_this.$refs.bdpri_list).bootstrapTable('destroy');
			$(_this.$refs.bdpri_list).bootstrapTable({
				pageNumber: 1,
				pageSize: 15,
				pageList: [],
				pagination: true,
				ajax: function(params) {
					_this.getBdpriList(params);
				},
				sidePagination: "server",
				columns: [{
					field: "shop_name",
					title: "门店",
					width: "10%",
					valign: 'middle'
				}, {
					field: "room_type_name",
					title: "适用包厢类型",
					width: "10%",
					valign: 'middle'
				}, {
					field: "week_cycle_name",
					title: "有效星期日",
					width: "13%",
					valign: 'middle'
				}, {
					field: "start_time",
					title: "可使用时间",
					width: "10%",
					valign: 'middle',
					formatter: function(value, row, index) {
						return row.start_time + ' - ' + row.end_time;
					}
				}, {
					field: "bd_price",
					title: "包断金额",
					width: "10%",
					valign: 'middle'
				}, {
					field: "bd_vip_price",
					title: "会员包断金额",
					width: "10%",
					valign: 'middle'
				}, {
					title: "操作",
					width: "10%",
					valign: 'middle',
					events: {
						'click .edit': function(e, value, row, index) {
							_this.bdpri_modify = 2;
							$(_this.$refs.bdpri_shop).val(row.shop_id).trigger('change');
							_this.getBdpriBoxtype(row.shop_id);
							_this.bdpri_boxtype_item = row.room_type;
							_this.bdpri_boxtype_txt = row.room_type_name;
							_this.bdpri_week_txt = row.week_cycle_name;
							_this.bdpri_week_item = row.week_cycle.split(',');
							_this.bdpri_start_time = row.start_time;
							_this.bdpri_end_time = row.end_time;
							_this.bdpri_use_time = row.start_time + ' - ' + row.end_time;
							_this.bdpri_bd = row.bd_price;
							_this.bdpri_vip_bd = row.bd_vip_price;
							_this.editBdpri('修改包断价格设置', row.id);
							for(var i = 1; i <= 10; i ++) {
								_this[`bd_vip_level${i}_price`] = row[`bd_vip_level${i}_price`]
							}
						},
						'click .del': function(e, value, row, index) {
							layer.confirm('删除后不可恢复，确定删除吗？', {
								btn: ['确定', '取消']
							}, function() {
								_this.delBdpri(row.id);
							});
						}
					},
					formatter: function(value, row, index) {
						return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;<span class="text-blue del">删除</span>'
					}
				}]
			});
		},
		getBdpriList: function(params) {
			let _this = this,
				pageNumber = 1;
			if(params != "" && params.data.offset != 0) {
				pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
			}
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"page": pageNumber,
						"page_size": params.data.limit,
						"start_time": _this.start_time,
						"end_time": _this.end_time,
						"shop_id": $.trim($(_this.$refs.bdpri_sel_shop).val()),
						"room_type": $.trim($(_this.$refs.bdpri_sel_type).val())
					}
				},
				"comment": ""
			};
			let datas2 = JSON.stringify(datas);
			$.ajax({
				type: "post",
				dataType: "json",
				url: Vue.ctUrl + "RoomTiming/getBdPriceSetList",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: {
					json: datas2
				},
				success: function(data) {
					if(data.response.result_code == "true") {
						params.success({
							total: data.response.result.total,
							rows: data.response.result.rows
						});
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data.response.error_msg);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		// 查询
		queryBdpri: function() {
			this.initBdpriTable();
		},
		// 点击新增
		addBdpri: function() {
			let _this = this;

			_this.bdpri_modify = '1';
			$(_this.$refs.bdpri_shop).val('').trigger('change');
			_this.bdpri_boxtype_item = [];
			_this.bdpri_boxtype_txt = '';
			_this.bdpri_week_item = [];
			_this.bdpri_week_txt = '';
			_this.bdpri_start_time = '';
			_this.bdpri_end_time = '';
			_this.bdpri_use_time = '';
			_this.bdpri_bd = '';
			_this.bdpri_vip_bd = '';
			_this.editBdpri('新增包断价格设置', '');
			for(var i = 1; i <= 10; i ++) {
				_this[`bd_vip_level${i}_price`] = ''
			}
		},
		// 包断门店
		getBdPriShop: function() {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						let arr = [];
						$.each(data.response.result, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						arr.shift();
						$(_this.$refs.bdpri_shop).select2({
							data: arr,
							allowClear: true,
							minimumResultsForSearch: -1,
							language: "zh-CN",
							width: '100%'
						}).on("select2:select", function(e) {
							_this.getBdpriBoxtype(e.params.data.id);
						});
						_this.getBdpriBoxtype($(_this.$refs.bdpri_shop).val());
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		// 包断包厢类型
		getBdpriBoxtype: function(shop_id) {
			let _this = this;
			
			let datas = {
				"header": Vue.request_header,
				"request": {
					"param": {
						"shop_id": shop_id
					}
				},
				"comment": ""
			};
			datas = JSON.stringify(datas);
			$.ajax({
				type: "POST",
				dataType: "json",
				url: Vue.ctUrl + "PublicData/api_getRoomType",
				async: false,
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: datas,
				success: function(data) {
					if(data['response']['result_code'] == "true") {
						_this.bdpri_boxtype_date = data.response.result.data;
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data["response"]["error_msg"]);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		},
		bdpriBoxtypeFun: function(e) {
			let _this = this;
			let c_bdpri_boxtype_item = _this.bdpri_boxtype_item;
			layer.confirm('', {
				skin: 'timing_room_type',
				type: 1,
				btn: ['确定', '取消'], // 按钮
				title: ['包厢类型', true],
				area: ['450px', ''], // 宽高
				content: $(_this.$refs.bdpri_boxtype_area),
				cancel: function() {
					// 右上角关闭
					if(_this.bdpri_boxtype_txt != "") {
						_this.bdpri_boxtype_item = c_bdpri_boxtype_item;
						return;
					}
					_this.bdpri_boxtype_item = [];
				}
			}, function() {
				let texts = [];
				_this.bdpri_boxtype_date.forEach(function(item) {
					_this.bdpri_boxtype_item.forEach(function(item2) {
						if(item.id == item2) {
							texts.push(item.name);
						}
					});
				});
				_this.bdpri_boxtype_txt = texts.join(",");
				layer.close(layer.index);
			}, function() {
				if(_this.bdpri_boxtype_txt != "") {
					_this.bdpri_boxtype_item = c_bdpri_boxtype_item;
					return;
				}
				_this.bdpri_boxtype_item = [];
			});
		},
		// 全选
		bdpriBoxtypeAll: function() {
			let _this = this;
			_this.bdpri_boxtype_all = _this.c_bdpri_boxtype_all;
			if(!_this.bdpri_boxtype_all) { // 实现全选
				_this.bdpri_boxtype_item = [];
				_this.bdpri_boxtype_date.forEach(function(item) {
					_this.bdpri_boxtype_item.push(item.id);
				});
			} else { // 实现反选
				_this.bdpri_boxtype_item = [];
			}
		},
		// 包断星期
		bdpriWeekFun: function(e) {
			let _this = this;
			let c_bdpri_week_item = _this.bdpri_week_item;
			layer.confirm('', {
				skin: 'timing_room_type',
				type: 1,
				btn: ['确定', '取消'], // 按钮
				title: ['有效星期日', true],
				area: ['450px', ''], // 宽高
				content: $(_this.$refs.bdpri_week_area),
				cancel: function() {
					// 右上角关闭
					if(_this.bdpri_week_txt != "") {
						_this.bdpri_week_item = c_bdpri_week_item;
						return;
					}
					_this.bdpri_week_item = [];
				}
			}, function() {
				let texts = [];
				_this.bdpri_week_date.forEach(function(item) {
					_this.bdpri_week_item.forEach(function(item2) {
						if(item.id == item2) {
							texts.push(item.name);
						}
					});
				});
				_this.bdpri_week_txt = texts.join(",");
				layer.close(layer.index);
			}, function() {
				if(_this.bdpri_week_txt != "") {
					_this.bdpri_week_item = c_bdpri_week_item;
					return;
				}
				_this.bdpri_week_item = [];
			});
		},
		// 全选
		bdpriWeekAll: function() {
			let _this = this;
			_this.bdpri_week_all = _this.c_bdpri_week_all;
			if(!_this.bdpri_week_all) { // 实现全选
				_this.bdpri_week_item = [];
				_this.bdpri_week_date.forEach(function(item) {
					_this.bdpri_week_item.push(item.id);
				});
			} else { // 实现反选
				_this.bdpri_week_item = [];
			}
		},
		// 包断使用时间
		bdpriTimeSel: function() {
			let _this = this;

			$(_this.$refs.bdpri_starthour).val(_this.bdpri_start_time.split(':')[0]).trigger('change');
			$(_this.$refs.bdpri_startseconds).val(_this.bdpri_start_time.split(':')[1]).trigger('change');
			$(_this.$refs.bdpri_stophour).val(_this.bdpri_end_time.split(':')[0]).trigger('change');
			$(_this.$refs.bdpri_stopseconds).val(_this.bdpri_end_time.split(':')[1]).trigger('change');
			layer.confirm('', {
				type: 1,
				btn: ['确定', '取消'], //按钮
				title: '使用时间选择',
				area: ['450px', ''], //宽高
				content:$(this.$refs.bdpri_time_range),
			}, function() {
				let starthour = $(_this.$refs.bdpri_starthour).select2("val");
				let startseconds = $(_this.$refs.bdpri_startseconds).select2("val");
				let stophour = $(_this.$refs.bdpri_stophour).select2("val");
				let stopseconds = $(_this.$refs.bdpri_stopseconds).select2("val");
				_this.bdpri_start_time = starthour + ":" + startseconds;
				_this.bdpri_end_time = stophour + ":" + stopseconds;
				_this.bdpri_use_time = _this.bdpri_start_time + " - " + _this.bdpri_end_time ;
				layer.close(layer.index);
			});
		},
		// 获取时间
		initBdpriTime: function() {
			let _this = this;
			let seconds = [];
			for(let i = 0; i < 60; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				seconds[i] = item;
			};
			let hour = [];
			for(let i = 0; i < 24; i++) {
				let item = {};
				item.id = (i < 10) ? '0' + i : i;
				item.text = (i < 10) ? '0' + i : i;
				hour[i] = item;
			}
			$(_this.$refs.bdpri_starthour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.bdpri_startseconds).select2({
				data: seconds,
				language: "zh-CN"
			});
			$(_this.$refs.bdpri_stophour).select2({
				data: hour,
				language: "zh-CN"
			});
			$(_this.$refs.bdpri_stopseconds).select2({
				data: seconds,
				language: "zh-CN"
			});
		},
		// 新增、修改包断
		editBdpri: function(name, id) {
			let _this = this;

			layer.confirm('', {
				skin: 'add_goods-alert',
				type: 1,
				btn: ['确定', '取消'],
				title: [name, true],
				area: ['1100px', ''],
				content: $(_this.$refs.bdpri_edit),
				offset: '100px'
			}, function() {
				if(_this.bdpri_bd < 0) {
					layer.msg('包断金额需大于0');
					return false;
				} else if(_this.bdpri_vip_bd < 0) {
					layer.msg('会员包断金额需大于0');
					return false;
				}
				let url = Vue.ctUrl + "RoomTiming/addBdPriceSet";
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.bdpri_shop).val(),
							"room_type": _this.bdpri_boxtype_item,
							"week_cycle": _this.bdpri_week_item.join(),
							"start_time": _this.bdpri_start_time,
							"end_time": _this.bdpri_end_time,
							"bd_price": _this.bdpri_bd,
							"bd_vip_price": _this.bdpri_vip_bd
						}
					},
					"comment": ""
				};
				for(var i = 1; i <= 10; i ++) {
					datas.request.param[`bd_vip_level${i}_price`] = _this[`bd_vip_level${i}_price`]
				}
				if(_this.bdpri_modify == '2') {
					datas["request"]["param"]["id"] = id;
					url = Vue.ctUrl + "RoomTiming/updateBdPriceSet";
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.closeAll();
							layer.msg('操作成功');
							$(_this.$refs.bdpri_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			});
		},
		// 删除包断
		delBdpri: function(id) {
			let _this = this;

			let datas = {
				"header": Vue.request_header,
				"request": {
					"version": Vue.version,
					"param": {
						"id": id
					}
				},
				"comment": ""
			};
			let datas2 = JSON.stringify(datas);
			$.ajax({
				type: "post",
				dataType: "json",
				url: Vue.ctUrl + "RoomTiming/delBdPriceSet",
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				data: {
					json: datas2
				},
				success: function(data) {
					if(data.response.result_code == "true") {
						layer.msg('删除成功');
						$(_this.$refs.bdpri_list).bootstrapTable("refresh");
					} else {
						Vue.timeoutfun(data.response.result_status, _this);
						layer.msg(data.response.error_msg);
					}
				},
				error: function(err) {
					layer.msg("出错啦");
				}
			});
		}

	}
}
</script>
<style lang="less">
	.timing_manage {
		.timing-list {
			.row-btn {
				margin: 0 0 30px;
				button {
					margin: 0 30px 0 0;
				}
			}
			p {
				color: #FF0707;
			}
			.table-responsive {
				table {
					table-layout: fixed;
					word-wrap: break-word;
				}
			}
		}
		.layer-repetition {
			.layui-layer-title {
				padding: 0;
			}
			.tip {
				text-align: center;
				color: #5e5e5e;
				font-size: 16px;
			}
			.tipcont {
				text-align: center;
				font-size: 14px;
				color:red;
			}
		}
		.row_magin_bottom {
			margin-bottom: 50px;
		}
		.control-label {
			text-align: right;
			line-height: 32px;
			font-size: 14px;
			font-weight: normal;
			color: #5e5e5e;
			padding-left: 0;
			padding-right: 0;
		}
		.bsSuggest_input {
			background: #fff!important;
		}
		.printer_arrow {
			height: 32px;
			position: absolute;
			top: 1px;
			right: 16px;
			width: 20px;
			cursor: pointer;
			b {
				border-color: #888 transparent transparent transparent;
				border-style: solid;
				border-width: 5px 4px 0 4px;
				height: 0;
				left: 50%;
				margin-left: -4px;
				margin-top: -2px;
				position: absolute;
				top: 50%;
				width: 0;
			}
		}
		.selection_clear {
			display: none;
			height: 32px;
			position: absolute;
			top: 1px;
			right: 36px;
			width: 20px;
			cursor: pointer;
			font-weight: bold;
			line-height: 32px;
		}
		.goods_checkboxdiv {
			position: relative;
			display: block;
			margin: 0 auto;
			width: 90%;
			padding: 30px 20px 20px;
		}
		.goods_checkboxdiv ul {
			border: 1px solid #e5e5e5;
			padding: 0px 30px 20px 120px;
			border-top: none;
		}
		.roomarea {
			border: none!important;
		}
		.roomarea li {
			width: 100%!important;
		}
		.timing_room_type .layui-layer-btn {
			text-align: center!important;
		}
		.timing_room_type .layui-layer-btn a {
			height: 32px!important;
			line-height: 32px!important;
			padding: 0 30px!important;
			margin:0px 20px!important;
		}
		.goods_checkboxdiv li {
			width: 14.28%;
			float: left;
			height: 32px;
			line-height: 32px;
			color: #a29d9d;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 14px;
		}
		.box_area {
			width: 100%;
			margin: 0!important;
			padding: 0px!important;
		}
		.box_area ul {
			margin-bottom: 0px;
			border: none;
		}
		.canselect {
			background-color: #eee!important;
		}
		.printer_detail_row div {
			line-height: 32px;
			color: #7b7b7b;
			word-break: break-all;
			min-height: 32px;
			border: 1px solid #e2e0e0;
		}
		.disabled-input[disabled] {
			background-color: #eee!important;
		}
		#chooseTime_popup {
			display: none;
			.chooseTime_popup-wrap {
				padding: 20px 60px;
				.chooseTime_popup_title {
					font-size: 16px;
					color: #333;
					margin: 10px;
				}
				.select2 {
					width: 150px!important;
				}
				.select2-selection--single {
					height: 46px;
					line-height: 46px;
					border-radius: 0!important;
					outline: none;
					border: 1px solid #d5d5d5!important;
					.select2-selection__rendered {
						line-height: 46px;
						color: #9d9d9d;
						font-size: 20px;
					}
					.select2-selection__arrow {
						height: 46px;
						line-height: 46px;
					}
				}
				.colon {
					width: 18px;
					text-align: center;
					line-height: 45px;
					font-size: 20px;
					color: #9d9d9d;
					margin-bottom: 0px;
				}
			}
		}
		.rule-con {
			margin: 50px 0 0;
			.page_header {
				text-align: center;
			}
			button {
				margin: 0 0 30px;
			}
		}
		.rule-edit, .bdpri-edit {
			display: none;
			padding: 30px;
			.col-md-6 {
				>div {
					margin: 0 0 20px;
				}
			}
		}

		.price-set-title {
			padding: 0 40px 20px 40px;
		}
		.price-set-row {
			padding: 20px 55px 10px 55px;
			color: #5e5e5e;
			display: flex;
			flex-direction: row;
			align-items: center;
			.row-title {
				margin-right: 20px;
			}
			.item {
				display: flex;
				flex-direction: row;
				align-items: center;
				margin-right: 20px;
				.txt {
					margin-right: 10px;
				}
				input {
					width: 130px;
				}
				.price {
					width: 130px;
					text-indent: 15px;
					line-height: 32px;
				    color: #7b7b7b;
				    min-height: 32px;
				    border: 1px solid #e2e0e0;
				}
			}
		}
	}
</style>